<div class="assign-modal">
    <div class="heading">
        <h4>Assign form</h4>
        <img class="close-modal"
             (click)="onModalClose()"
             src="assets/icons/clear.png" />
    </div>
    <div class="assign-info">
        <div class="half">
            <p class="inner-half label">Program: </p>
            <p class="inner-half">{{program.name}}</p>
        </div>
        <div class="half">
            <p class="inner-half label">User:</p>
            <p class="inner-half">{{user.email}}</p>
        </div>
    </div>
    <form #assignForm="ngForm"
          (ngSubmit)="canAssign && onFormSubmit()">
        <div class="form-row">
            <div class="form-row-input">
                <p class="input-label">Price</p>
                <input type="number"
                       [required]="enablePaidProgramAssignment && !freeProgram"
                       name="price"
                       [disabled]="freeProgram || !enablePaidProgramAssignment"
                       class="input"
                       [(ngModel)]="price"
                       [ngClass]="{ 'form-submitted': assignForm.submitted }" />
            </div>
            <div class="form-row-input">
                <p class="input-label">Currency</p>
                <ng-select name="currency"
                           class="select-input"
                           placeholder="Select currency"
                           [searchable]="false"
                           [disabled]="freeProgram || !enablePaidProgramAssignment"
                           [required]="enablePaidProgramAssignment && !freeProgram"
                           [items]="currencyList"
                           [(ngModel)]="currencyCode"
                           [ngClass]="{ 'form-submitted': assignForm.submitted }">
                </ng-select>
            </div>
        </div>
        <div *ngIf="!enablePaidProgramAssignment"
             class="form-row">
            <p class="input-notice">
                Assigning paid programs to users is not enabled
            </p>
        </div>
        <div class="form-row">
            <div class="form-row-input d-flex align-items-center">
                <input type="checkbox" 
                       class="checkbox input-checkbox"
                       [class.true]="freeProgram"
                       [class.false]="!freeProgram"
                       name="free_proram"
                       [disabled]="!enablePaidProgramAssignment"
                       [(ngModel)]="freeProgram"/>
                <p class="input-label">Free plan</p>
            </div>
        </div>
        <div class="form-row form-row-submit">
            <button type="submit"
                    class="button-gray"
                    [disabled]="!canAssign">Assign</button>
        </div>
    </form>
</div>